import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useFlashMessage } from "@/app/(main)/(club)/mes-clubs/[id]/components/use-flash-message";
import { useModalStore } from "@/stores/modal-store";
import { ApiWriteResponse, EventRead } from "@/TS/Interfaces/global_interfaces";
interface MutationParams {
  type: string;
  clubSlug: string;
  startDate: string;
}
export const useDeleteEventDocument = () => {
  const $ = _c(10);
  const {
    close
  } = useModalStore();
  const queryClient = useQueryClient();
  const {
    showFlashMessage
  } = useFlashMessage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["event-document"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient || $[2] !== showFlashMessage) {
    t1 = async (_, variables) => {
      const dateOnly = variables.startDate?.split("T")[0];
      const monthStartDate = dayjs(dateOnly).startOf("month").format("YYYY-MM-DD");
      const eventQueryKey = ["clubEvent", variables.type, variables.clubSlug, dateOnly];
      await queryClient.invalidateQueries({
        queryKey: eventQueryKey,
        exact: true,
        refetchType: "all"
      });
      const eventsListQueryKey = ["events", variables.clubSlug, monthStartDate];
      await queryClient.invalidateQueries({
        queryKey: eventsListQueryKey,
        exact: true,
        refetchType: "all"
      });
      showFlashMessage("Le compte rendu a \xE9t\xE9 supprim\xE9 avec succ\xE8s !", "success2", "mes-clubs-calendar");
    };
    $[1] = queryClient;
    $[2] = showFlashMessage;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== close || $[5] !== showFlashMessage) {
    t2 = _error => {
      close();
      showFlashMessage("Une erreur est survenue lors de la suppression du compte rendu", "primary", "mes-clubs-calendar");
    };
    $[4] = close;
    $[5] = showFlashMessage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      mutationKey: t0,
      mutationFn: _temp,
      onSuccess: t1,
      onError: t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useMutation(t3);
};
async function _temp(t0) {
  const {
    type,
    clubSlug,
    startDate
  } = t0;
  const response = await fetch(`/api/event-document?type=${type}&clubSlug=${clubSlug}&startDate=${startDate}`, {
    method: "DELETE"
  });
  if (!response.ok) {
    throw new Error("Erreur lors de la suppression du compte rendu");
  }
  return response.json();
}